/* ============================================================
   Отправка заявки из формы заказа
   ============================================================ */
import type { OrderPayload } from './types';

/**
 * Отправка заявки.
 *
 * Сейчас это ЗАГЛУШКА: данные логируются в консоль и имитируется
 * сетевая задержка. Подключите реальную отправку одним из способов ниже.
 *
 * Рекомендация: НЕ храните токен Telegram-бота на фронтенде. Сделайте
 * маленький серверный endpoint (Node/Cloudflare Worker/Vercel Function),
 * который примет payload и сам вызовет Telegram Bot API.
 */
export async function submitOrder(payload: OrderPayload): Promise<void> {
  // Для отладки во время разработки:
  console.info('[order] payload →', payload);

  // ── Вариант A. Свой backend (рекомендуется) ───────────────
  const res = await fetch('/api/order', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  if (!res.ok) throw new Error(`Order failed: ${res.status}`);

  // ── Вариант B. Telegram Bot API напрямую ──────────────────
  // (только если осознанно готовы держать токен на клиенте)
  // const TOKEN = import.meta.env.VITE_TG_BOT_TOKEN;
  // const CHAT_ID = import.meta.env.VITE_TG_CHAT_ID;
  // const text = [
  //   '🛡 Новая заявка BITSECURE',
  //   `Компания: ${payload.company}`,
  //   `Email: ${payload.email}`,
  //   `Способ связи: ${payload.method} — ${payload.contact}`,
  //   `Услуга: ${payload.serviceName}`,
  //   payload.comment ? `Комментарий: ${payload.comment}` : '',
  //   `Язык сайта: ${payload.lang}`,
  // ].filter(Boolean).join('\n');
  // const res = await fetch(`https://api.telegram.org/bot${TOKEN}/sendMessage`, {
  //   method: 'POST',
  //   headers: { 'Content-Type': 'application/json' },
  //   body: JSON.stringify({ chat_id: CHAT_ID, text }),
  // });
  // if (!res.ok) throw new Error(`Telegram failed: ${res.status}`);

}
